import { fetcher } from "helpers/fetcher";

import { TGetBUStaffMemberReq, TGetBUStaffMemberRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getBUStaffMember = async (params?: TGetBUStaffMemberReq) => {
  return await fetcher<TGetBUStaffMemberRes, TGetBUStaffMemberReq>(
    ENDPOINT.BU.GET_BU_STAFF_MEMBER,
    {
      params: params?.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.BU.GET_BU_STAFF_MEMBER.version,
        [API_HEADER.BU_ID]: params?.idBu,
      },
    }
  );
};

export const queryGetBUStaffMember = async (params?: TGetBUStaffMemberReq) => {
  return (await getBUStaffMember(params)).data;
};

queryGetBUStaffMember._key = (params?: TGetBUStaffMemberReq) => [
  ENDPOINT.BU.GET_BU_STAFF_MEMBER.url,
  params,
];
